import { byWindowAction, sendRequest } from '@html/_common/utils';

import AOCarousel from '@atomic/organisms/_common/carousel/carousel';

export default class AMAlternativeItineraries {
  constructor(common, tourId, tourName) {
    this.carousel = new AOCarousel('.js-am-tour-alternative-itineraries__carousel');
    this.common = common;
    this.tourId = tourId;
    this.tourName = tourName;
    this.initiated = false;
  }

  /* initiate alternative itineraries slider */
  initiate() {
    if ($('.alt_itn').length > 0) {
      const $itnBlock = $('.js-ao-tour-itinerary');
      const $window = $(window);
      byWindowAction(['scroll'], () => {
        if (!this.initiated
          && ($window.scrollTop() + $window.height()) >= $itnBlock.offset().top) {
          this.loadItineraries();
        }
      });
      if (!this.initiated && ($window.scrollTop() + $window.height()) >= $itnBlock.offset().top) {
        this.loadItineraries();
      }
    }
  }

  loadItineraries() {
    this.initiated = true;
    const $altBlock = $('.alt_itn');
    sendRequest(
      '/api/tour/load',
      {
        action: 'alternative_itineraries',
        id: this.tourId,
        group_id: $altBlock.data('group-id'),
      },
      (data) => {
        if (data && data.status === 'OK') {
          $altBlock.replaceWith(data.component);
          this.carousel.initiate();
        }
      },
    );
  }
}
